import type { Role } from '@/types';

/** Discount Configuration access (story 110056): Admin + Super Admin only.
 *  Operational Associate, Dealer and Field Installer denied.
 *  Config-layer nav (src/config/nav.tsx) inlines the same array (cannot import feature). */
export const DISCOUNTS_ROLES: Role[] = ['admin', 'super_admin'];

/** Human page name for the access-denied toast (ADR-0014) →
 *  "…permission to access Discount Management." */
export const DISCOUNTS_PAGE_NAME = 'Discount Management';

/** Discount API error codes (ADR-0008 envelope / ADR-0010 — branch on the code, never `error.message`).
 *  Only the two Create codes here; status/delete tickets add their own (e.g. DISCOUNT_EXPIRED). */
export const DISCOUNT_ERROR_CODES = {
  NAME_EXISTS: 'DISCOUNT_NAME_EXISTS',
  /** 422 — the discount **domain** checks (a tier value over the Step-1 cap, a price-exceeds). */
  VALIDATION_FAILED: 'DISCOUNT_VALIDATION_FAILED',
  /** 400 — the shared DTO layer (`validation.filter.ts`), which is what the tier Min/Max Qty cap
   *  answers with. A different code from the 422 above, and field-addressed in exactly the same
   *  way, so both must reach the same detail handling: branching on the 422 alone dropped every
   *  payload-level refusal onto the generic toast (ADO 117110, probed live 2026-09-22). */
  PAYLOAD_INVALID: 'VALIDATION_FAILED',
} as const;
